export default __webpack_public_path__ + "static/media/quality_analysis.f92a6daf.csv";